module.exports = __webpack_public_path__ + "static/media/dashboard.9d1c6fa4.png";